/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_decrease_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is the same magnitude, but a decrease is shown as a positive number here, whereas percentage change keeps the sign (negative for a drop).`)
};

const es_pct_decrease_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es la misma magnitud, pero aquí la disminución se muestra como un número positivo, mientras que el cambio porcentual conserva el signo (negativo para una caída).`)
};

const de_pct_decrease_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Betrag ist derselbe, aber ein Rückgang wird hier als positive Zahl angezeigt, während die prozentuale Veränderung das Vorzeichen beibehält (negativ bei einem Rückgang).`)
};

const nl_pct_decrease_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het gaat om dezelfde grootte, maar een daling wordt hier als een positief getal getoond, terwijl percentageverandering het teken behoudt (negatief bij een daling).`)
};

const fr_pct_decrease_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est la même ampleur, mais la diminution est affichée ici sous forme de nombre positif, tandis que la variation en pourcentage conserve le signe (négatif pour une baisse).`)
};

const it_pct_decrease_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È la stessa entità, ma qui il calo viene mostrato come numero positivo, mentre la variazione percentuale mantiene il segno (negativo per una diminuzione).`)
};

const pt_br2_pct_decrease_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É a mesma magnitude, mas aqui a diminuição é mostrada como um número positivo, enquanto a variação percentual mantém o sinal (negativo para uma queda).`)
};

const pt_pct_decrease_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É a mesma magnitude, mas aqui a diminuição é apresentada como um número positivo, enquanto a variação percentual mantém o sinal (negativo para uma queda).`)
};

const ja_pct_decrease_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大きさは同じですが、パーセント減少では下落が正の数で表されるのに対し、パーセント変化では符号が保持されます（下落の場合は負の値）。`)
};

const zh_pct_decrease_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`两者数值大小相同，但百分比减少在这里以正数表示，而百分比变化保留符号（下降为负数）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_decrease_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_decrease_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_decrease_faq2_a", locale)
	if (locale === "en") return en_pct_decrease_faq2_a(inputs)
	if (locale === "es") return es_pct_decrease_faq2_a(inputs)
	if (locale === "de") return de_pct_decrease_faq2_a(inputs)
	if (locale === "nl") return nl_pct_decrease_faq2_a(inputs)
	if (locale === "fr") return fr_pct_decrease_faq2_a(inputs)
	if (locale === "it") return it_pct_decrease_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_pct_decrease_faq2_a(inputs)
	if (locale === "pt") return pt_pct_decrease_faq2_a(inputs)
	if (locale === "ja") return ja_pct_decrease_faq2_a(inputs)
	return zh_pct_decrease_faq2_a(inputs)
};